<template>
  <div class="virtual-pin-input">
    <div class="pin-display">
      <label class="pin-label">{{ label }}</label>
      <div class="pin-input-container">
        <input
          :type="showPin ? 'text' : 'password'"
          :value="inputText"
          readonly
          class="pin-input"
          :placeholder="placeholder"
        />
<!--        <button @click="showPin = !showPin" class="toggle-visibility">-->
<!--          {{ showPin ? '🙈' : '👁️' }}-->
<!--        </button>-->
      </div>
    </div>

    <div class="pin-grid">
      <div class="pin-row" v-for="(row, rowIndex) in pinRows" :key="rowIndex">
        <button
          v-for="key in row"
          :key="key"
          @click="handleKeyClick(key)"
          :class="[
            'pin-key',
            {
              'pin-backspace': key === '⌫',
              'pin-clear': key === 'C',
              'pin-submit': key === 'OK',
              'pin-empty': key === ''
            }
          ]"
          :disabled="isKeyDisabled(key)"
        >
          {{ key }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VirtualPinInput",
  props: {
    label: {
      type: String,
      default: "PIN eingeben"
    },
    placeholder: {
      type: String,
      default: ""
    },
    maxLength: {
      type: Number,
      default: 6
    }
  },
  data() {
    return {
      inputText: "",
      showPin: false,
      // Klassisches Telefon-Layout
      pinRows: [
        ['1', '2', '3'],
        ['4', '5', '6'],
        ['7', '8', '9'],
        ['C', '0', '⌫'],
        ['OK']
      ]
    };
  },
  methods: {
    handleKeyClick(key) {
      if (key === '⌫') {
        this.inputText = this.inputText.slice(0, -1);
      } else if (key === 'C') {
        this.inputText = "";
      } else if (key === 'OK') {
        if (this.inputText.length > 0) {
          this.$emit('enter', this.inputText);
          this.inputText = ""; // Optional: Reset nach Absenden
        }
      } else if (key !== '') {
        if (this.inputText.length < this.maxLength) {
          this.inputText += key;
        }
      }
    },
    isKeyDisabled(key) {
      // Deaktiviert Zahlen, wenn maxLength erreicht ist
      if (!isNaN(key) && this.inputText.length >= this.maxLength) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.virtual-pin-input {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 350px; /* Schmaler als das Keyboard */
  margin: 0 auto;
  font-family: 'Segoe UI', Roboto, sans-serif;
  background: #f9f9f9;
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.pin-display {
  width: 100%;
  margin-bottom: 20px;
}

.pin-label {
  display: block;
  font-size: 18px;
  color: #444;
  margin-bottom: 8px;
  text-align: center;
}

.pin-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.pin-input {
  width: 100%;
  font-size: 28px;
  letter-spacing: 5px;
  padding: 12px;
  text-align: center;
  border-radius: 8px;
  border: 2px solid #ddd;
  background: white;
}

.toggle-visibility {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
}

.pin-grid {
  display: grid;
  gap: 10px;
  width: 100%;
}

.pin-row {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.pin-key {
  flex: 1;
  height: 65px;
  font-size: 24px;
  font-weight: bold;
  border: 1px solid #ccc;
  border-radius: 12px;
  background: white;
  cursor: pointer;
  transition: all 0.1s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pin-key:active:not(:disabled) {
  background-color: #e0e0e0;
  transform: scale(0.95);
}

.pin-key:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pin-backspace {
  background-color: #ffebee;
  color: #c62828;
}

.pin-clear {
  background-color: #f5f5f5;
  color: #616161;
}

.pin-submit {
  background-color: #4CAF50;
  color: white;
  margin-top: 5px;
  width: 100%;
  height: 55px;
}

.pin-submit:hover {
  background-color: #43a047;
}
</style>
